export default {
    token: undefined,
    user: {id: undefined, mail: undefined, name: undefined, tel: undefined, units: undefined, timezone: undefined, tzname: undefined},
    language: undefined,
    sites: [],
    isSynchronizing: true,
    events: [],
    siloSelected: undefined,
    siteSelected: undefined,
    viewDetails: false
}